module.exports = __webpack_public_path__ + "static/media/Gamex.9d2636bb.apk";